<div class="configuration-list-container">
  <section class="feature-page">
    <app-page-header
      title="Nombramientos"
      subtitle="Gestiona los nombramientos disponibles en el sistema"
      icon="volunteer_activism">
    </app-page-header>

    <div class="feature-page__content">
      <mat-card class="table-surface-card">
        <mat-card-content>
          <app-table-surface
              [columns]="columns"
              [data]="tableData"
              [isLoading]="isLoading"
              [enableDragDrop]="enableDragDrop"
              [cellTemplate]="cellTemplate"
              [savingCell]="savingCell"
              [activeFilters]="activeFilterChips"
              tableId="assignment-list"
              [enableSearch]="true"
              searchPlaceholder="Buscar nombramiento..."
              [enableFilter]="true"
              [enableColumnVisibility]="true"
              [enableDensity]="true"
              primaryActionLabel="Nuevo"
              (searchChange)="onToolbarSearch($event)"
              (filterRemove)="onFilterRemove($event)"
              (rowReorder)="onAssignmentReorder($event)"
              (cellEditSave)="onCellEditSave($event)"
              (primaryActionClick)="createNew()">
              <div filterPanel class="assignment-filter-panel" [formGroup]="filterForm">
                <app-data-table-multi-select-filter formControlName="status" label="Estado" [options]="statusFilterOptions"></app-data-table-multi-select-filter>
                <app-data-table-multi-select-filter formControlName="areaId" label="Área" [options]="areaSelectOptions"></app-data-table-multi-select-filter>
                <app-data-table-multi-select-filter formControlName="level" label="Nivel" [options]="levelSelectOptions"></app-data-table-multi-select-filter>
                <app-data-table-multi-select-filter formControlName="requiresActiveMinistry" label="Ministerio" [options]="ministryFilterOptions"></app-data-table-multi-select-filter>

              </div>
            </app-table-surface>

          <!-- Template para renderizar celdas personalizadas -->
          <ng-template #cellTemplate let-column="column" let-row="row">
            <span *ngIf="column === 'name'">{{ row.name }}</span>
            <span *ngIf="column === 'area'">{{ row.areaName }}</span>
            <span *ngIf="column === 'levels'">{{ (row.allowedOrganizationLevelNames || []).join(', ') || '-' }}</span>
            <span *ngIf="column === 'requiresActiveMinistry'">{{ row.requiresActiveMinistry ? 'Si' : 'No' }}</span>
            <mat-slide-toggle
              *ngIf="column === 'isActive'"
              class="status-toggle"
              [checked]="row.isActive"
              (click)="$event.stopPropagation()"
              (change)="onStatusChange(row, $event.checked)"
              aria-label="Cambiar estado">
            </mat-slide-toggle>
            <div *ngIf="column === 'actions'" class="actions-cell">
              <button mat-icon-button matTooltip="Editar" (click)="$event.stopPropagation(); editAssignment(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Eliminar" (click)="$event.stopPropagation(); deleteAssignment(row)">
                <mat-icon color="warn">delete</mat-icon>
              </button>
            </div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </section>
</div>
